<template>
	<div class="bf bgfff plr20" style="min-height: 100vh;">
		<div class="pt20 pb20  bor_b flex_items flex_between"
			v-for="(item,index) in list" :key="index">
			<div>{{item.date}}{{item.time == 'forenoon' ? '上午' : item.time == 'afternoon' ? '下午' : ''}}</div>
			<div class="red" v-if="item.is_leave">请假</div>
			<div class="main_color" v-if="item.is_sign">已签到</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				list: [],
				id: '',
			}
		},
		methods: {
			getList() {
				this.api.signLogs({},this.id).then(res => {
					this.list = res.data;
				})
			}
		},
		created() {
			this.id = this.$route.query.id;
			
			this.getList()
		}
	}
</script>

<style>
</style>
